import { get } from 'lodash';

export const requestedUserName = (request: any) =>
  `${get(request, 'requestedBy.lastName', '') || ''} ${
    get(request, 'requestedBy.firstName', '') || ''
  }`;
